import { BASE_URL } from 'utils/constants';

export const detailsDefault = {
  personalInfo: {
    profilePicture: '',
    logo: '',
    signOff: '',
    fullName: '',
    jobTitle: '',
    department: '',
    company: '',
  },
  contactInfo: {
    phone: '',
    mobile: '',
    workEmail: '',
    website: '',
    location: '',
  },
  socialMedialLinks: {
    facebook: '',
    twitter: '',
    instagram: '',
    linkedin: '',
    youtube: '',
    whatsapp: '',
  },
};

// const baseUrl = process.env.REACT_APP_UI_URL;

export const detailsInitial = {
  personalInfo: {
    profilePicture: `${BASE_URL}/icons/profile.png`,
    logo: `${BASE_URL}/icons/logo.png`,
    signOff: 'Best Regards',
    fullName: 'Dilip Kumar',
    jobTitle: 'CEO',
    department: 'Executive',
    company: 'Pulpy',
  },
  contactInfo: {
    phone: '+91 12345 67890',
    mobile: '+91 12345 67890',
    workEmail: 'example@pulpy.io',
    website: 'https://pulpy.io',
    location: 'Chicago, IL, USA',
  },
  socialMedialLinks: {
    facebook: 'https://facebook.com/pulpy/',
    twitter: 'https://twitter.com/pulpy/',
    instagram: 'https://instagram.com/pulpy/',
    linkedin: 'https://linkedin.com/pulpy/',
    youtube: '',
    whatsapp: '',
  },
};

export const meetingDetailsDefault = {
  personalInfo: {
    logo: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    company: '',
  },
  contactInfo: {
    phone: '',
    workEmail: '',
    location: '',
  },
  socialMedialLinks: {
    facebook: '',
    twitter: '',
    instagram: '',
    linkedin: '',
  },
};

export const meetingDetailsInitial = {
  personalInfo: {
    // logo: 'https://pulpy-contacts-frontend.s3.amazonaws.com/pulpy-icon.png',
    logo: `${BASE_URL}/pulpyLogo.png`,
    firstName: 'Dilip',
    lastName: 'Kumar',
    jobTitle: 'CEO',
    company: 'Pulpy',
  },
  contactInfo: {
    phone: '',
    workEmail: '',
    location: 'Chicago, IL, USA',
  },
  socialMedialLinks: {
    facebook: '@Dilipkumar',
    twitter: '@Dilipkumar_2',
    instagram: '@Dilip_kumar',
    linkedin: '@Dilip_kumar',
  },
};
